import { mod } from '../core/math';

// track an animation cursor with support for repeat and ping-pong loop modes
class AnimCursor {
    duration: number = 0;

    loopMode: 'none' | 'repeat' | 'pingpong' = 'none';

    timer: number = 0;

    cursor: number = 0;

    // 播放倍速；update 时缩放 deltaTime，供 headless viewer 暴露运镜倍速控制
    timeScale: number = 1;

    constructor(duration: number, loopMode: 'none' | 'repeat' | 'pingpong') {
        this.reset(duration, loopMode);
    }

    update(deltaTime: number) {
        const dt = deltaTime * this.timeScale;

        // update animation timer
        this.timer += dt;

        // update the track cursor
        this.cursor += dt;

        if (this.cursor >= this.duration) {
            switch (this.loopMode) {
                case 'none': this.cursor = this.duration; break;
                case 'repeat': this.cursor %= this.duration; break;
                case 'pingpong': this.cursor %= (this.duration * 2); break;
            }
        }
    }

    reset(duration: number, loopMode: 'none' | 'repeat' | 'pingpong') {
        this.duration = duration;
        this.loopMode = loopMode;
        this.timer = 0;
        this.cursor = 0;
    }

    set value(value: number) {
        if (this.loopMode === 'none') {
            this.cursor = Math.max(0, Math.min(value, this.duration));
            return;
        }
        this.cursor = mod(value, this.duration);
    }

    get value() {
        return this.cursor > this.duration ? 2 * this.duration - this.cursor : this.cursor;
    }
}

export { AnimCursor };
